import React, { useState } from "react";
import { Table, Button } from "react-bootstrap";

const reportUrls = {
  CS: "https://app.powerbi.com/view?r=eyJrIjoiZjdjMWM3OWYtYzFjMC00YmVjLThlOWYtNDQwODMxOGM4ODYwIiwidCI6IjBlNTI1YjNlLTc2NTgtNGI2Zi1hYmJkLTU5N2E4M2UwYzMxNiIsImMiOjl9",
  Co2: "https://app.powerbi.com/view?r=eyJrIjoiNjBmODRmOGItNmI0Mi00NDE1LTgxZDQtMTRhMGIzMWIwODQyIiwidCI6IjBlNTI1YjNlLTc2NTgtNGI2Zi1hYmJkLTU5N2E4M2UwYzMxNiIsImMiOjl9",
  TTR: "https://app.powerbi.com/view?r=eyJrIjoiMjA4MmUwZTYtNjg4ZS00YzkyLTgyY2EtYWMzOTU0MmZjMjI0IiwidCI6IjBlNTI1YjNlLTc2NTgtNGI2Zi1hYmJkLTU5N2E4M2UwYzMxNiIsImMiOjl9"

};

const SevenYReports  = () => {
  const [activeReportKey, setActiveReportKey] = useState(null);

  const links = [
    { name: "Cost Report", key: "CS", internal: true },
    { name: "Co2 Report", key: "Co2", internal: true },
    { name: "Transit Time Report", key: "TTR", internal: true},
   
  ];

  const handleClick = (link) => {
    if (link.internal && link.key in reportUrls) {
      setActiveReportKey(link.key);
    } else if (link.url) {
      window.open(link.url, "_blank", "noopener,noreferrer");
    }
  };

  const handleBack = () => setActiveReportKey(null);

  if (activeReportKey && reportUrls[activeReportKey]) {
    return (
      <div style={{ margin: "10px" }}>
        <Button
          variant="secondary"
          onClick={handleBack}
          style={{ marginBottom: "15px" }}
        >
          &lt; Back to Reports
        </Button>
        <div style={{ width: "100%", height: "100vh" }}>
          <iframe
            title="Power BI Report"
            width="100%"
            height="100%"
            src={reportUrls[activeReportKey]}
            allowFullScreen
            style={{ border: "none" }}
          ></iframe>
        </div>
      </div>
    );
  }

  return (
    <div style={{ margin: "10px" }}>
      <h5 className="mb-3">7Y Reports</h5>
      <Table bordered size="sm" className="text-center align-middle">
        <thead className="table-light">
          <tr>
            <th style={{ width: "5%" }}>#</th>
            <th style={{ textAlign: "left" }}>Report Name</th>
            <th style={{ width: "10%" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {links.map((link, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td style={{ textAlign: "left" }}>{link.name}</td>
              <td>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleClick(link)}
                >
                  View
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default SevenYReports ;
